export const getBackendError = (err) => {
    let rawError =
        err?.response?.data?.detail ||
        err?.response?.data?.[0] ||
        err?.response?.data?.error_payment ||
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        (err?.response?.data && typeof err?.response?.data === 'object' ? Object.values(err.response.data)[0] : null) ||
        err?.message ||
        "Ocurrió un error inesperado";

    if (Array.isArray(rawError)) {
        return rawError.join(" ");
    }

    if (typeof rawError === "string" && rawError.startsWith("['")) {
        try {
            const parsed = JSON.parse(rawError.replace(/'/g, '"'));
            if (Array.isArray(parsed)) return parsed.join(" ");
            return parsed;
        } catch {
            return rawError.replace(/[\\[\]']/g, "");
        }
    }

    if (typeof rawError === "string" && rawError.includes("Estructura inválida")) {
        return "La información enviada está incompleta o tiene un formato no válido.";
    }

    return rawError;
};
